import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[conversationalChatMessage]',
    standalone: false
})
export class ConversationalChatMessageDirective {
    public viewContainerRef = inject(ViewContainerRef);
}
